// Mock data for Zonik Solutions website

export const navigationLinks = [
  { name: 'Leistungen', path: '/leistungen' },
  { name: 'Über uns', path: '/ueber-uns' },
  { name: 'Kontakt', path: '/kontakt' }
];

export const services = [
  {
    id: 'webentwicklung',
    title: 'Webentwicklung',
    shortDescription: 'Moderne, performante Websites, die Ihre Kunden begeistern',
    description: 'Wir entwickeln maßgeschneiderte Websites, die nicht nur gut aussehen, sondern messbare Ergebnisse liefern. Von der ersten Idee bis zum Launch – technisch sauber, SEO-optimiert und conversion-fokussiert.',
    features: [
      'Responsive Design für alle Geräte',
      'Schnelle Ladezeiten und Performance',
      'SEO-optimierte Struktur',
      'Moderne Technologien (React, Next.js)',
      'Individuelle Features nach Bedarf'
    ],
    icon: 'Code'
  },
  {
    id: 'app-entwicklung',
    title: 'App-Entwicklung',
    shortDescription: 'Native und plattformübergreifende Apps für Ihr Business',
    description: 'Von der Idee zur fertigen App. Wir entwickeln mobile Anwendungen, die Ihre Nutzer lieben werden. Technisch robust, benutzerfreundlich und skalierbar.',
    features: [
      'iOS und Android Apps',
      'Cross-Platform Entwicklung',
      'Intuitive Benutzeroberflächen',
      'Backend-Integration',
      'App Store Optimierung'
    ],
    icon: 'Smartphone'
  },
  {
    id: 'google-ads',
    title: 'Google Ads',
    shortDescription: 'Gezielte Kampagnen für maximale Sichtbarkeit und Conversions',
    description: 'Wir bringen Ihr Unternehmen genau dann vor die richtigen Augen, wenn Ihre Kunden nach Ihnen suchen. Professionelles Setup, kontinuierliche Optimierung und transparentes Reporting.',
    features: [
      'Kampagnen-Setup von Grund auf',
      'Keyword-Recherche und Strategie',
      'Anzeigentexte und Landing Pages',
      'Performance-Optimierung',
      'Monatliches Reporting und Analysen'
    ],
    icon: 'Target'
  },
  {
    id: 'seo-marketing',
    title: 'SEO & Online-Marketing',
    shortDescription: 'Langfristige Sichtbarkeit in Suchmaschinen aufbauen',
    description: 'Organische Rankings, die bleiben. Wir optimieren Ihre Website für Google und bauen nachhaltige Online-Präsenz auf, die kontinuierlich qualifizierten Traffic bringt.',
    features: [
      'On-Page und Technical SEO',
      'Content-Strategie',
      'Local SEO für regionale Sichtbarkeit',
      'Link-Building',
      'Performance-Tracking und Reports'
    ],
    icon: 'TrendingUp'
  }
];

export const geoLocations = [
  {
    id: 'halstenbek',
    name: 'Halstenbek',
    title: 'Webentwicklung Halstenbek',
    description: 'Als lokaler Partner in Halstenbek entwickeln wir moderne Websites für Unternehmen in der Region.',
    region: 'Halstenbek und Umgebung'
  },
  {
    id: 'hamburg',
    name: 'Hamburg',
    title: 'Webentwicklung Hamburg',
    description: 'Professionelle Webentwicklung für Unternehmen in Hamburg und der Metropolregion.',
    region: 'Hamburg'
  }
];

export const whyChooseUs = [
  {
    title: 'Technische Exzellenz',
    description: 'Wir arbeiten mit modernsten Technologien und Best Practices. Jede Website wird performant, sicher und zukunftssicher entwickelt.'
  },
  {
    title: 'Transparente Kommunikation',
    description: 'Sie wissen jederzeit, wo Ihr Projekt steht. Keine versteckten Kosten, keine Überraschungen. Nur ehrliche, klare Zusammenarbeit.'
  },
  {
    title: 'Messbare Ergebnisse',
    description: 'Wir entwickeln nicht für Preise, sondern für Erfolg. Conversion-Optimierung, SEO und Performance stehen im Mittelpunkt jedes Projekts.'
  },
  {
    title: 'Deutschlandweite Betreuung',
    description: 'Egal ob München, Berlin, Hamburg oder Köln – wir betreuen Unternehmen in ganz Deutschland. Remote-First mit persönlichem Touch.'
  }
];

export const companyInfo = {
  name: 'Zonik Solutions',
  address: 'Friedrichshulder Weg 157A',
  postalCode: '25469',
  city: 'Halstenbek',
  email: 'info@zonik-solutions.de',
  phone: '+49 (0) 123 456789',
  coordinates: {
    lat: 53.64585,
    lng: 9.84923
  }
};

export const testimonials = [
  {
    name: 'Michael Schmidt',
    company: 'Schmidt Consulting GmbH',
    text: 'Die neue Website hat unsere Online-Anfragen verdreifacht. Professionelle Arbeit von A bis Z.',
    rating: 5
  },
  {
    name: 'Sarah Müller',
    company: 'Müller & Partner',
    text: 'Schnelle Umsetzung, faire Preise und ein Team, das versteht, was wir brauchen. Klare Empfehlung.',
    rating: 5
  }
];

export const portfolioProjects = [
  {
    title: 'E-Commerce Platform',
    category: 'Webentwicklung',
    description: 'Moderne E-Commerce-Lösung mit Payment-Integration, Produktverwaltung und responsive Design für einen führenden Online-Händler.',
    tech: ['React', 'Node.js', 'MongoDB', 'Stripe'],
    results: [
      '+150% mehr Online-Verkäufe',
      '< 2 Sek. Ladezeit',
      '95/100 Lighthouse Score'
    ],
    icon: 'Code'
  },
  {
    title: 'Corporate Website',
    category: 'Webentwicklung & SEO',
    description: 'Professionelle Unternehmenswebsite mit integriertem CMS, mehrsprachig und vollständig SEO-optimiert für internationale Märkte.',
    tech: ['Next.js', 'Headless CMS', 'SEO-Optimierung'],
    results: [
      '+200% organischer Traffic',
      'Top 3 Rankings für Hauptkeywords',
      '40% mehr Anfragen'
    ],
    icon: 'TrendingUp'
  },
  {
    title: 'Mobile App',
    category: 'App-Entwicklung',
    description: 'Native iOS & Android App für Fitness-Tracking mit Echtzeit-Synchronisation, Push-Notifications und In-App-Käufen.',
    tech: ['React Native', 'Firebase', 'REST API'],
    results: [
      '50.000+ Downloads',
      '4.8★ App Store Rating',
      '85% User Retention'
    ],
    icon: 'Smartphone'
  }
];

export const blogPosts = [
  {
    id: 1,
    slug: 'webentwicklung-trends-2025',
    title: 'Webentwicklung Trends 2025: Das müssen Sie wissen',
    excerpt: 'Die digitale Landschaft entwickelt sich rasant weiter. Erfahren Sie, welche Technologien und Ansätze 2025 dominieren werden.',
    category: 'Webentwicklung',
    date: '10. Dezember 2024',
    readTime: '5 Min. Lesezeit',
    icon: 'Code'
  },
  {
    id: 2,
    slug: 'seo-strategie-2025',
    title: 'SEO-Strategie 2025: So ranken Sie auf Seite 1',
    excerpt: 'Google Updates, KI-Integration und User Experience – wir zeigen Ihnen, wie Sie Ihre SEO-Strategie zukunftssicher aufstellen.',
    category: 'SEO & Marketing',
    date: '5. Dezember 2024',
    readTime: '7 Min. Lesezeit',
    icon: 'TrendingUp'
  },
  {
    id: 3,
    slug: 'conversion-optimierung-tipps',
    title: '10 Conversion-Tipps, die sofort wirken',
    excerpt: 'Kleine Änderungen, große Wirkung. Diese 10 praxiserprobten Tipps helfen Ihnen, mehr Besucher in Kunden zu verwandeln.',
    category: 'Online Marketing',
    date: '1. Dezember 2024',
    readTime: '6 Min. Lesezeit',
    icon: 'Lightbulb'
  },
  {
    id: 4,
    slug: 'app-entwicklung-kosten',
    title: 'App-Entwicklung: Was kostet eine professionelle App?',
    excerpt: 'Transparente Einblicke in Kosten, Zeitaufwand und die Faktoren, die den Preis einer mobilen App beeinflussen.',
    category: 'App-Entwicklung',
    date: '28. November 2024',
    readTime: '8 Min. Lesezeit',
    icon: 'Code'
  },
  {
    id: 5,
    slug: 'google-ads-fehler',
    title: 'Die 5 häufigsten Google Ads Fehler (und wie Sie sie vermeiden)',
    excerpt: 'Budget verbrennen war gestern. Lernen Sie die kritischsten Fehler kennen und wie Sie Ihre Kampagnen profitabel machen.',
    category: 'Google Ads',
    date: '22. November 2024',
    readTime: '5 Min. Lesezeit',
    icon: 'TrendingUp'
  },
  {
    id: 6,
    slug: 'website-performance',
    title: 'Website-Performance: Speed ist King',
    excerpt: 'Jede Sekunde Ladezeit kostet Conversions. Wir zeigen Ihnen, wie Sie Ihre Website blitzschnell machen.',
    category: 'Webentwicklung',
    date: '18. November 2024',
    readTime: '6 Min. Lesezeit',
    icon: 'Lightbulb'
  }
];

export const faqData = [
  {
    question: 'Wie lange dauert die Entwicklung einer Website?',
    answer: 'Die Entwicklungszeit hängt vom Umfang ab. Eine einfache Business-Website ist in 2-4 Wochen fertig, komplexere Projekte mit Custom-Features können 8-12 Wochen dauern. Wir erstellen Ihnen nach dem Erstgespräch einen detaillierten Zeitplan.'
  },
  {
    question: 'Was kostet eine professionelle Website?',
    answer: 'Die Kosten variieren je nach Anforderungen. Eine Business-Website startet bei ca. 3.000€, E-Commerce-Lösungen ab 8.000€. Wir erstellen Ihnen gerne ein individuelles Angebot basierend auf Ihren Zielen und Features.'
  },
  {
    question: 'Bieten Sie auch Wartung und Support an?',
    answer: 'Ja, wir bieten verschiedene Wartungspakete an. Von monatlichen Updates und Backups bis hin zu kontinuierlicher Weiterentwicklung – wir sorgen dafür, dass Ihre Website immer aktuell und sicher bleibt.'
  },
  {
    question: 'Arbeiten Sie nur mit Kunden aus Hamburg?',
    answer: 'Nein, wir arbeiten deutschlandweit. Dank digitaler Prozesse und Video-Calls können wir Projekte remote genauso effizient umsetzen wie vor Ort. Viele unserer Kunden sitzen in Berlin, München, Köln und anderen Städten.'
  },
  {
    question: 'Kann ich meine Website selbst pflegen?',
    answer: 'Absolut! Wir entwickeln mit benutzerfreundlichen CMS-Lösungen, die Sie nach einer kurzen Einweisung selbst bedienen können. Für technische Änderungen stehen wir natürlich jederzeit zur Verfügung.'
  },
  {
    question: 'Wie läuft die Zusammenarbeit ab?',
    answer: 'Nach einem kostenlosen Erstgespräch erstellen wir ein Konzept und Angebot. Bei Beauftragung folgen Design-Entwürfe, Feedback-Runden und die technische Umsetzung. Sie haben jederzeit Einblick in den Projektfortschritt und können Feedback geben.'
  }
];